/**
 * Created by anthony on 6/24/14.
 */

var apWizardModel = angular.module('apWizardModel', ['familyModel']);
apWizardModel.factory('ApWizardModelFactory', function(ApplicationService, AbstractModelService, FamilyModelFactory){
    var ApWizardModel = function(familyID){
        this.endpoint = "/apWizard";
        this.dataProperty = "apWizard";
        this.familyID = familyID;
    }
    ApWizardModel.prototype = new FamilyModelFactory();
    ApWizardModel.prototype.parent = FamilyModelFactory.prototype;
    ApWizardModel.prototype.put = function(id, data, instance)
    {
        return AbstractModelService.put("/api/family/" + this.familyID + "/apWizard/" + id, data, instance);
    }
    ApWizardModel.prototype.new = function()
    {
        return {'case65': 1, 'case66': 1, 'case67': 1, 'case68': 1, 'case69': 1, 'case70': 1, 'case71': 1, 'case72': 1, 'case73': 1, 'case74': 1, 'case75': 1,
                'case76': 1, 'case77': 1, 'case78': 1, 'case79': 1, 'case80': 1, 'case81': 1, 'case82': 1, 'case83': 1, 'case84': 1, 'case85': 1, 'case65ans': '', 
                'case66ans': '', 'case67ans': '', 'case68ans': '', 'case69ans': '', 'case70ans': '', 'case71ans': '', 'case72ans': '', 'case73ans': '', 
                'case74ans': '', 'case75ans': '', 'case76ans': '', 'case77ans': '', 'case78ans': '', 'case79ans': '', 'case81ans': '', 'case82ans': '', 
                'case83ans': '', 'case84ans': '', 'case85ans': '', 'calculated': 0, 'viewedLetter': 0, 'viewedOtherDesc': 0, 'viewedSsq': 0, 'viewedFamily': 0, 
                'completedFlags': ''};
    }
    return ApWizardModel;

});
